import type { MonitoringClient } from './MonitoringClient';
import { CustomMonitoringClient } from './CustomMonitoringClient';
import { NoOpMonitoringClient } from './NoOpMonitoringClient';
import { SSRMonitoringClient } from './SSRMonitoringClient';
import { initializeSentry } from './sentry';

let monitoringClient: MonitoringClient;
export const getMonitoringClient = (): MonitoringClient => {
	if (!monitoringClient) {
		if (/bot/i.test(window.navigator.userAgent)) {
			// Do nothing for search engine crawlers
			monitoringClient = new NoOpMonitoringClient();
		} else if (process.env.REACT_SSR) {
			// Don't confuse errors from SSR with SPA
			// Error from SSR will be collected and returned to cc-frontend-ssr
			monitoringClient = new SSRMonitoringClient();
		} else {
			monitoringClient = new CustomMonitoringClient();
		}
	}

	return monitoringClient;
};

export const enableNewSentry = (): void => {
	if (process.env.REACT_SSR) {
		return;
	}

	initializeSentry();
	if (monitoringClient instanceof CustomMonitoringClient) {
		monitoringClient.enableNewSentry();
	}
};

export const enableSendErrorsToTelemetryService = (): void => {
	if (process.env.REACT_SSR) {
		return;
	}

	if (monitoringClient instanceof CustomMonitoringClient) {
		monitoringClient.enableSendErrorsToTelemetryService();
	}
};
